import { readable, writable } from 'svelte/store';

import { BizCardsService } from '@client/services/bizcards';

import { activeDomain } from './domain-settings';

/**
 * A store that indicates whether fields used by the current domain are being loaded.
 * @type {import('svelte/store').Writable<boolean>}
 */
export const loading = writable(false);

/**
 * A store that holds an array of strings representing business card and signature fields
 * used by the current domain.
 * @type {import('svelte/store').Readable<string[]>}
 */
export const fields = readable([], (set) => {
  const fetchData = async () => {
    loading.set(true);

    try {
      /** @type {string[]} */
      const result = await BizCardsService.getFields();
      set(result);
    } catch (error) {
      console.error('Failed to fetch business card fields:', error);
      set([]);
    } finally {
      loading.set(false);
    }
  };

  const unsubscribe = activeDomain.subscribe((domain) => {
    if (domain) {
      fetchData();
    } else {
      set([]);
    }
  });

  return () => {
    unsubscribe();
  };
});
